export const QUALITY_EVENT_NAME = 'upcomingAGBPriceChangesModal2025';

export enum QUALITY_EVENT_ACTIONS {
    SHOWN = 'popup_viewed',
    CLOSED = 'popup_closed',
    ACCEPTED = 'popup_accepted'
}

export const documentMap = {
    de: {
        privacyPolicy: 'https://eduki.com/agbs/German_2025-07-01_T&C.pdf',
        dataProtection: 'https://eduki.com/agbs/German_2025-07-01_DPA.pdf'
    },
    gr: {
        privacyPolicy: 'https://eduki.com/agbs/Greek_2025-07-01_T&C.pdf',
        dataProtection: 'https://eduki.com/agbs/Grrek_2025-04-15_DPA.pdf'
    },
    es: {
        privacyPolicy: 'https://eduki.com/agbs/Spanish_2025_07_01_T&C.pdf',
        dataProtection: 'https://eduki.com/agbs/Spanish_2025_07-01_DPA.pdf'
    },
    it: {
        privacyPolicy: 'https://eduki.com/agbs/Italian_2025-07-01_T&C.pdf',
        dataProtection: 'https://eduki.com/agbs/Italian_2025-07-01_DPA.pdf'
    },
    fr: {
        privacyPolicy: 'https://eduki.com/agbs/French_2025-07-01_T&C.pdf',
        dataProtection: 'https://eduki.com/agbs/French_2025-07-01_DPA.pdf'
    },
    bg: {
        privacyPolicy: 'https://eduki.com/agbs/Bulgaria_2025-07-01_T&C.pdf',
        dataProtection: 'https://eduki.com/agbs/Bulgaria_2025-07-01_DPA.pdf'
    },
    cn: {
        privacyPolicy: 'https://eduki.com/agbs/Chinese_2025-07-01_T&C.pdf',
        dataProtection: 'https://eduki.com/agbs/Chinese_2025-07-01_DPA.pdf'
    },
    cz: {
        privacyPolicy: 'https://eduki.com/agbs/Czech_2025-07-01_T&C.pdf',
        dataProtection: 'https://eduki.com/agbs/Czech_2025-07-01_DPA.pdf'
    },
    dk: {
        privacyPolicy: 'https://eduki.com/agbs/Danish_2025-07-01_T&C.pdf',
        dataProtection: 'https://eduki.com/agbs/Danish_2025-07-01_DPA.pdf'
    },
    fi: {
        privacyPolicy: 'https://eduki.com/agbs/Finnish_2025-07-01_T&C.pdf',
        dataProtection: 'https://eduki.com/agbs/Finnish_2025-07-01_DPA.pdf'
    },
    in: {
        privacyPolicy: 'https://eduki.com/agbs/Hindi_2025-07-01_T&C.pdf',
        dataProtection: 'https://eduki.com/agbs/Hindi_2025-07-01_DPA.pdf'
    },
    hr: {
        privacyPolicy: 'https://eduki.com/agbs/Croatian_2025-07-01_T&C.pdf',
        dataProtection: 'https://eduki.com/agbs/Croatia_2025-07-01_DPA.pdf'
    },
    hu: {
        privacyPolicy: 'https://eduki.com/agbs/Hungarian_2025-07-01_T&C.pdf',
        dataProtection: 'https://eduki.com/agbs/Hungarian_2025-07-01_DPA.pdf'
    },
    id: {
        privacyPolicy: 'https://eduki.com/agbs/Indonesia_2025-07-01_T&C.pdf',
        dataProtection: 'https://eduki.com/agbs/Indonesia_2025-07-01_DPA.pdf'
    },
    jp: {
        privacyPolicy: 'https://eduki.com/agbs/Japan_2025-07-01_T&C.pdf',
        dataProtection: 'https://eduki.com/agbs/Japan_2025-07-01_DPA.pdf'
    },
    kr: {
        privacyPolicy: 'https://eduki.com/agbs/Korean_2025-07-01_T&C.pdf',
        dataProtection: 'https://eduki.com/agbs/Korean_2025-07-01_DPA.pdf'
    },
    kz: {
        privacyPolicy: 'https://eduki.com/agbs/Kazahk_2025-07-01_T&C.pdf',
        dataProtection: 'https://eduki.com/agbs/Kazahk_2025-07-01_DPA.pdf'
    },
    my: {
        privacyPolicy: 'https://eduki.com/agbs/Malayan_2025-07-01_T&C.pdf',
        dataProtection: 'https://eduki.com/agbs/Malay_2025-07-01_DPA.pdf'
    },
    no: {
        privacyPolicy: 'https://eduki.com/agbs/Norway_2025-07-01_T&C.pdf',
        dataProtection: 'https://eduki.com/agbs/Norway_2025-07-01_DPA.pdf'
    },
    pl: {
        privacyPolicy: 'https://eduki.com/agbs/Polish_2025-07-01_T&C.pdf',
        dataProtection: 'https://eduki.com/agbs/Polish_2025-07-01_DPA.pdf'
    },
    ro: {
        privacyPolicy: 'https://eduki.com/agbs/Romania_2025-07-01_T&C.pdf',
        dataProtection: 'https://eduki.com/agbs/Romanian_2025-07-01_DPA.pdf'
    },
    rs: {
        privacyPolicy: 'https://eduki.com/agbs/Serbian_2025-07-01_T&C.pdf',
        dataProtection: 'https://eduki.com/agbs/Serbia_2025-07-01_DPA.pdf'
    },
    se: {
        privacyPolicy: 'https://eduki.com/agbs/Sweden_2025-07-01_T&C.pdf',
        dataProtection: 'https://eduki.com/agbs/Sweden_2025-07-01_DPA.pdf'
    },
    sk: {
        privacyPolicy: 'https://eduki.com/agbs/Slovakian_2025-07-01_T&C.pdf',
        dataProtection: 'https://eduki.com/agbs/Slovakian_2025-07-01_DPA.pdf'
    },
    th: {
        privacyPolicy: 'https://eduki.com/agbs/Thai_2025-07-01_T&C.pdf',
        dataProtection: 'https://eduki.com/agbs/Thai_2025-07-01_DPA.pdf'
    },
    ua: {
        privacyPolicy: 'https://eduki.com/agbs/Ukraine_2025-07-01_T&C.pdf',
        dataProtection: 'https://eduki.com/agbs/Ukranian_2025-07-01_DPA.pdf'
    }
};
